import React from 'react';
// import ReactDOM from 'react-dom/client';
import styles from './WowFind.scss';
import classNames from 'classnames/bind';

// import Adsense970250 from 'components/adsense/Adsense970250';
import Adsense72890 from 'components/adsense/Adsense72890';

const cx = classNames.bind(styles);
let glang = 'kr';

const rank_color = {
  artifact: '#e5cc80', astounding: '#e268a8', legend: '#ff8000'
}

const wclFilter = {
  'wclFilter0': [
    {filterName_eng: 'dps', classes_eng: '', classes: '', color: 'white', filterName: '피해', value:'metric=dps'},
    {filterName_eng: 'hps', classes_eng: '', classes: '', color: 'white', filterName: '치유', value:'metric=hps'}
  ],
  'wclFilter1': [
    {filterName_eng: 'Allboss', classes_eng: '', classes: '', color: 'white', filterName: '모든보스', value:''},
    // {filterName_eng: '', classes_eng: '', classes: '', color: 'white', filterName: '에라노그', value:'&boss=2587'},
    // {filterName_eng: '', classes_eng: '', classes: '', color: 'white', filterName: '테로스', value:'&boss=2639'},
    // {filterName_eng: '', classes_eng: '', classes: '', color: 'white', filterName: '원시의회', value:'&boss=2590'},
    // {filterName_eng: '', classes_eng: '', classes: '', color: 'white', filterName: '세나스', value:'&boss=2592'},
    // {filterName_eng: '', classes_eng: '', classes: '', color: 'white', filterName: '다테아', value:'&boss=2635'},
    // {filterName_eng: '', classes_eng: '', classes: '', color: 'white', filterName: '그림토템', value:'&boss=2605'},
    // {filterName_eng: '', classes_eng: '', classes: '', color: 'white', filterName: '디우르나', value:'&boss=2614'},
    // {filterName_eng: '', classes_eng: '', classes: '', color: 'white', filterName: '라자게스', value:'&boss=2607'},
    // {filterName_eng: 'Kazzara', classes_eng: '', classes: '', color: 'white', filterName: '카자라', value:'&boss=2688'},
    // {filterName_eng: 'Amalgamation Chamber', classes_eng: '', classes: '', color: 'white', filterName: '융합체의방', value:'&boss=2687'},
    // {filterName_eng: 'Forgotten Experiments', classes_eng: '', classes: '', color: 'white', filterName: '잊힌실험체', value:'&boss=2693'},
    // {filterName_eng: 'Assault of the Zaqali', classes_eng: '', classes: '', color: 'white', filterName: '자칼리의습격', value:'&boss=2682'},
    // {filterName_eng: 'Rashok, the Elder', classes_eng: '', classes: '', color: 'white', filterName: '장로라소크', value:'&boss=2680'},
    // {filterName_eng: 'Zskarn', classes_eng: '', classes: '', color: 'white', filterName: '지스카른', value:'&boss=2689'},
    // {filterName_eng: 'Magmorax', classes_eng: '', classes: '', color: 'white', filterName: '마그모락스', value:'&boss=2683'},
    // {filterName_eng: 'Echo of Neltharion', classes_eng: '', classes: '', color: 'white', filterName: '넬타리온', value:'&boss=2684'},
    // {filterName_eng: 'Sarkareth', classes_eng: '', classes: '', color: 'white', filterName: '사카레스', value:'&boss=2685'},
    // {filterName_eng: 'Gnalroot', classes_eng: '', classes: '', color: 'white', filterName: '옹이뿌리', value:'&boss=2820'},
    // {filterName_eng: 'Igira the Cruel', classes_eng: '', classes: '', color: 'white', filterName: '잔혹한이기라', value:'&boss=2709'},
    // {filterName_eng: 'Volcoross', classes_eng: '', classes: '', color: 'white', filterName: '볼코로스', value:'&boss=2737'},
    // {filterName_eng: 'Council of Dreams', classes_eng: '', classes: '', color: 'white', filterName: '꿈의의회', value:'&boss=2728'},
    // {filterName_eng: 'Larodar', classes_eng: '', classes: '', color: 'white', filterName: '라로다르', value:'&boss=2731'},
    // {filterName_eng: 'Nymue', classes_eng: '', classes: '', color: 'white', filterName: '니무에', value:'&boss=2708'},
    // {filterName_eng: 'Smolderon', classes_eng: '', classes: '', color: 'white', filterName: '스몰데론', value:'&boss=2824'},
    // {filterName_eng: 'Tindral Sageswift', classes_eng: '', classes: '', color: 'white', filterName: '틴드랄세이지스위프트', value:'&boss=2786'},
    // {filterName_eng: 'Fyrakk the Blazing', classes_eng: '', classes: '', color: 'white', filterName: '광염의피락', value:'&boss=2677'},
    // {filterName_eng: 'Allstar', classes_eng: '', classes: '', color: 'white', filterName: '올스타', value:'&boss=-1'}
    // {filterName_eng: 'Ulgrax', classes_eng: '', classes: '', color: 'white', filterName: '울그락스', value:'&boss=2902'},
    // {filterName_eng: 'The Bloodbound Horror', classes_eng: '', classes: '', color: 'white', filterName: '피결속공포', value:'&boss=2917'},
    // {filterName_eng: 'Sikran', classes_eng: '', classes: '', color: 'white', filterName: '시크란', value:'&boss=2898'},
    // {filterName_eng: 'Rashanan', classes_eng: '', classes: '', color: 'white', filterName: '라샤난', value:'&boss=2918'},
    // {filterName_eng: 'Ovinax', classes_eng: '', classes: '', color: 'white', filterName: '오비낙스', value:'&boss=2919'},
    // {filterName_eng: 'Kyveza', classes_eng: '', classes: '', color: 'white', filterName: '카이베자', value:'&boss=2920'},
    // {filterName_eng: 'The Silken Court', classes_eng: '', classes: '', color: 'white', filterName: '비단궁정', value:'&boss=2921'},
    // {filterName_eng: 'Ansurek', classes_eng: '', classes: '', color: 'white', filterName: '안수레크', value:'&boss=2922'},
    // {filterName_eng: 'Allstar', classes_eng: '', classes: '', color: 'white', filterName: '올스타', value:'&boss=-1'}
    {filterName_eng: 'Vexie and the Geargrinders', classes_eng: '', classes: '', color: 'white', filterName: '벡시와연마공', value:'&boss=3009'},
    {filterName_eng: 'Cauldron of Carnage', classes_eng: '', classes: '', color: 'white', filterName: '살육의도가니', value:'&boss=3010'},
    {filterName_eng: 'Rik Reverb', classes_eng: '', classes: '', color: 'white', filterName: '리크리버브', value:'&boss=3011'},
    {filterName_eng: 'Stix Bunkjunker', classes_eng: '', classes: '', color: 'white', filterName: '스틱스벙크정커', value:'&boss=3012'},
    {filterName_eng: 'Lockenstock', classes_eng: '', classes: '', color: 'white', filterName: '로켄스톡', value:'&boss=3013'},
    {filterName_eng: 'One-Armed Bandit', classes_eng: '', classes: '', color: 'white', filterName: '외팔이좀도둑', value:'&boss=3014'},
    {filterName_eng: 'MugZee', classes_eng: '', classes: '', color: 'white', filterName: '머그지', value:'&boss=3015'},
    {filterName_eng: 'Gallywix', classes_eng: '', classes: '', color: 'white', filterName: '갤리윅스', value:'&boss=3016'},
    {filterName_eng: 'Allstar', classes_eng: '', classes: '', color: 'white', filterName: '올스타', value:'&boss=-1'}
  ],
  'wclFilter2': [
    {filterName_eng: 'Mythic', classes_eng: '', classes: '', color: 'white', filterName: '신화', value:'&difficulty=5'},
    {filterName_eng: 'Heroic', classes_eng: '', classes: '', color: 'white', filterName: '영웅', value:'&difficulty=4'},
    {filterName_eng: 'Normal', classes_eng: '', classes: '', color: 'white', filterName: '일반', value:'&difficulty=3'},
    {filterName_eng: 'LFR', classes_eng: '', classes: '', color: 'white', filterName: '공격대찾기', value:'&difficulty=1'}
  ],
  'wclFilter3': [
    {filterName_eng: 'WORLD', classes_eng: '', classes: '', color: 'white', filterName: '월드', value:'&region=0'},
    {filterName_eng: 'KOREA', classes_eng: '', classes: '', color: 'white', filterName: '국내', value:'&region=3'}
  ],
  'wclFilter4': [
    {filterName_eng: 'AllClasses', classes_eng: '', classes: '', color: '#fff', filterName: '모든클래스', value:''},
    {filterName_eng: 'DeathKnight', classes_eng: '', classes: '', color: '#c41f3b', filterName: '죽음의기사', value:'&class=DeathKnight'}, 
    {filterName_eng: 'DeathKnight', classes_eng: 'Blood', classes: '죽음의기사', color: '#c41f3b', filterName: '혈기', value:'&class=DeathKnight&spec=Blood'},
    {filterName_eng: 'DeathKnight', classes_eng: 'Frost', classes: '죽음의기사', color: '#c41f3b', filterName: '냉기', value:'&class=DeathKnight&spec=Frost'},
    {filterName_eng: 'DeathKnight', classes_eng: 'Unholy', classes: '죽음의기사', color: '#c41f3b', filterName: '부정', value:'&class=DeathKnight&spec=Unholy'},
    {filterName_eng: 'DemonHunter', classes_eng: '', classes: '', color: '#a330c9', filterName: '악마사냥꾼', value:'&class=DemonHunter'}, 
    {filterName_eng: 'DemonHunter', classes_eng: 'Havoc', classes: '악마사냥꾼', color: '#a330c9', filterName: '파멸', value:'&class=DemonHunter&spec=Havoc'},
    {filterName_eng: 'DemonHunter', classes_eng: 'Vengeance', classes: '악마사냥꾼', color: '#a330c9', filterName: '복수', value:'&class=DemonHunter&spec=Vengeance'},
    {filterName_eng: 'Druid', classes_eng: '', classes: '', color: '#ff7d0a', filterName: '드루이드', value:'&class=Druid'},
    {filterName_eng: 'Druid', classes_eng: 'Balance', classes: '드루이드', color: '#ff7d0a', filterName: '조화', value:'&class=Druid&spec=Balance'},
    {filterName_eng: 'Druid', classes_eng: 'Feral', classes: '드루이드', color: '#ff7d0a', filterName: '야성', value:'&class=Druid&spec=Feral'},
    {filterName_eng: 'Druid', classes_eng: 'Guardian', classes: '드루이드', color: '#ff7d0a', filterName: '수호', value:'&class=Druid&spec=Guardian'},
    {filterName_eng: 'Druid', classes_eng: 'Restoration', classes: '드루이드', color: '#ff7d0a', filterName: '회복', value:'&class=Druid&spec=Restoration'},
    {filterName_eng: 'Evoker', classes_eng: '', classes: '', color: '#33937f', filterName: '기원사', value:'&class=Evoker'}, 
    {filterName_eng: 'Evoker', classes_eng: 'Devastation', classes: '기원사', color: '#33937f', filterName: '황폐', value:'&class=Evoker&spec=Devastation'},
    {filterName_eng: 'Evoker', classes_eng: 'Preservation', classes: '기원사', color: '#33937f', filterName: '보존', value:'&class=Evoker&spec=Preservation'},
    {filterName_eng: 'Evoker', classes_eng: 'Augmentation', classes: '기원사', color: '#33937f', filterName: '증강', value:'&class=Evoker&spec=Augmentation'},
    {filterName_eng: 'Hunter', classes_eng: '', classes: '', color: '#abd473', filterName: '사냥꾼', value:'&class=Hunter'}, 
    {filterName_eng: 'Hunter', classes_eng: 'BeastMastery', classes: '사냥꾼', color: '#abd473', filterName: '야수', value:'&class=Hunter&spec=BeastMastery'},
    {filterName_eng: 'Hunter', classes_eng: 'Marksmanship', classes: '사냥꾼', color: '#abd473', filterName: '사격', value:'&class=Hunter&spec=Marksmanship'},
    {filterName_eng: 'Hunter', classes_eng: 'Survival', classes: '사냥꾼', color: '#abd473', filterName: '생존', value:'&class=Hunter&spec=Survival'},
    {filterName_eng: 'Mage', classes_eng: '', classes: '', color: '#69ccf0', filterName: '마법사', value:'&class=Mage'}, 
    {filterName_eng: 'Mage', classes_eng: 'Arcane', classes: '마법사', color: '#69ccf0', filterName: '비전', value:'&class=Mage&spec=Arcane'},
    {filterName_eng: 'Mage', classes_eng: 'Fire', classes: '마법사', color: '#69ccf0', filterName: '화염', value:'&class=Mage&spec=Fire'},
    {filterName_eng: 'Mage', classes_eng: 'Frost', classes: '마법사', color: '#69ccf0', filterName: '냉기', value:'&class=Mage&spec=Frost'},
    {filterName_eng: 'Monk', classes_eng: '', classes: '', color: '#00ff98', filterName: '수도사', value:'&class=Monk'}, 
    {filterName_eng: 'Monk', classes_eng: 'Brewmaster', classes: '수도사', color: '#00ff98', filterName: '양조', value:'&class=Monk&spec=Brewmaster'},
    {filterName_eng: 'Monk', classes_eng: 'Mistweaver', classes: '수도사', color: '#00ff98', filterName: '운무', value:'&class=Monk&spec=Mistweaver'},
    {filterName_eng: 'Monk', classes_eng: 'Windwalker', classes: '수도사', color: '#00ff98', filterName: '풍운', value:'&class=Monk&spec=Windwalker'},
    {filterName_eng: 'Paladin', classes_eng: '', classes: '', color: '#f58cba', filterName: '성기사', value:'&class=Paladin'}, 
    {filterName_eng: 'Paladin', classes_eng: 'Holy', classes: '성기사', color: '#f58cba', filterName: '신성', value:'&class=Paladin&spec=Holy'},
    {filterName_eng: 'Paladin', classes_eng: 'Protection', classes: '성기사', color: '#f58cba', filterName: '보호', value:'&class=Paladin&spec=Protection'},
    {filterName_eng: 'Paladin', classes_eng: 'Retribution', classes: '성기사', color: '#f58cba', filterName: '징벌', value:'&class=Paladin&spec=Retribution'},
    {filterName_eng: 'Priest', classes_eng: '', classes: '', color: '#fff', filterName: '사제', value:'&class=Priest'}, 
    {filterName_eng: 'Priest', classes_eng: 'Discipline', classes: '사제', color: '#fff', filterName: '수양', value:'&class=Priest&spec=Discipline'},
    {filterName_eng: 'Priest', classes_eng: 'Holy', classes: '사제', color: '#fff', filterName: '신성', value:'&class=Priest&spec=Holy'},
    {filterName_eng: 'Priest', classes_eng: 'Shadow', classes: '사제', color: '#fff', filterName: '암흑', value:'&class=Priest&spec=Shadow'},
    {filterName_eng: 'Rogue', classes_eng: '', classes: '', color: '#fff569', filterName: '도적', value:'&class=Rogue'}, 
    {filterName_eng: 'Rogue', classes_eng: 'Assassination', classes: '도적', color: '#fff569', filterName: '암살', value:'&class=Rogue&spec=Assassination'},
    {filterName_eng: 'Rogue', classes_eng: 'Subtlety', classes: '도적', color: '#fff569', filterName: '잠행', value:'&class=Rogue&spec=Subtlety'},
    {filterName_eng: 'Rogue', classes_eng: 'Outlaw', classes: '도적', color: '#fff569', filterName: '무법', value:'&class=Rogue&spec=Outlaw'},
    {filterName_eng: 'Shaman', classes_eng: '', classes: '', color: '#2459ff', filterName: '주술사', value:'&class=Shaman'}, 
    {filterName_eng: 'Shaman', classes_eng: 'Elemental', classes: '주술사', color: '#2459ff', filterName: '정기', value:'&class=Shaman&spec=Elemental'},
    {filterName_eng: 'Shaman', classes_eng: 'Enhancement', classes: '주술사', color: '#2459ff', filterName: '고양', value:'&class=Shaman&spec=Enhancement'},
    {filterName_eng: 'Shaman', classes_eng: 'Restoration', classes: '주술사', color: '#2459ff', filterName: '복원', value:'&class=Shaman&spec=Restoration'},
    {filterName_eng: 'Warlock', classes_eng: '', classes: '', color: '#9482c9', filterName: '흑마법사', value:'&class=Warlock'}, 
    {filterName_eng: 'Warlock', classes_eng: 'Affliction', classes: '흑마법사', color: '#9482c9', filterName: '고통', value:'&class=Warlock&spec=Affliction'},
    {filterName_eng: 'Warlock', classes_eng: 'Demonology', classes: '흑마법사', color: '#9482c9', filterName: '악마', value:'&class=Warlock&spec=Demonology'},
    {filterName_eng: 'Warlock', classes_eng: 'Destruction', classes: '흑마법사', color: '#9482c9', filterName: '파괴', value:'&class=Warlock&spec=Destruction'},
    {filterName_eng: 'Warrior', classes_eng: '', classes: '', color: '#c79c6e', filterName: '전사', value:'&class=Warrior'}, 
    {filterName_eng: 'Warrior', classes_eng: 'Arms', classes: '전사', color: '#c79c6e', filterName: '무기', value:'&class=Warrior&spec=Arms'},
    {filterName_eng: 'Warrior', classes_eng: 'Fury', classes: '전사', color: '#c79c6e', filterName: '분노', value:'&class=Warrior&spec=Fury'},
    {filterName_eng: 'Warrior', classes_eng: 'Protection', classes: '전사', color: '#c79c6e', filterName: '방어', value:'&class=Warrior&spec=Protection'},
  ]
}

const LankObject = ({
  cnt, classColor, name, region, txt3, report_code, fightID, amount, server_name, 
  specIconIndex, sourceID, getReportData, sourceID_ing, compTxt3
}) => {
  const regionTxt = txt3 === '국내' ? '' : (region !== "" ? ` (${region})` : '');
  classColor = classColor === '#000' ? 'white' : classColor;

  const etc_style = {
    objectPosition: `calc(-${specIconIndex}px*18) 0px`
  }

  const isHeal = compTxt3.substring(0,2) === '치유' ? true : false;

  return (
    <div key={cnt} className={cx('data-row')}>
    <li className={cx('user')}>
      <span className={cx('item_span')}>
        <span className={cx('wcl-name')} onClick={() => getReportData({report_code, fightID, name, cnt})}>
          <span className={cx('lank')} style={cnt+1 === 1 ? {color:rank_color.artifact} : (cnt+1>25 ? {color:rank_color.legend} : {color:rank_color.astounding})}>{cnt+1}</span>
          <span className={cx('specicon')}>
            <img src='https://assets.rpglogs.com/img/warcraft/icons/actors.jpg?v=12' style={{objectPosition:etc_style.objectPosition}} alt={`특성아이콘${specIconIndex}`} />
          </span>
          <span style={{color:classColor}}> {name}{regionTxt}</span>
          <span className={cx('amount')}> {
            String(amount/1000).substring(0, String(amount/1000).indexOf('.')+2)
          }K</span>
        </span>
      </span>
      <span className={cx('item_span')}>
        <a className={cx('wowinfo')} href={`https://${glang==='kr'?'ko.':''}warcraftlogs.com/character/${region.toLowerCase()}/${server_name}/${name}`} target="_blank" rel="noreferrer">
          <img src='https://assets.rpglogs.com/img/warcraft/favicon.png?v=2' alt={`${name}의 WCL로그`} />
        </a>
        <a className={cx('wowinfo')} href={`https://worldofwarcraft.blizzard.com/ko-kr/character/${region.toLowerCase()}/${server_name.replace(/\s/g,'-')}/${name}`} target="_blank" rel="noreferrer">
          <img src='https://images.blz-contentstack.com/v3/assets/blt72f16e066f85e164/bltc3d5627fa96394bf/world-of-warcraft.webp?width=96&format=webply&quality=95' alt={`${name}의 전투정보실`} />
        </a>
        <a className={cx('wowinfo')} href={`https://raider.io/characters/${region.toLowerCase()}/${server_name.replace(/\s/g,'-')}/${name}`} target="_blank" rel="noreferrer">
          <img src='https://cdnassets.raider.io/images/brand/Icon_FullColor_Square.png' alt={`${name}의 Raider.io`}/>
        </a>
        <a className={cx('wowinfo')} href={`https://www.raidbots.com/simbot/quick?region=${region.toLowerCase()}&realm=${server_name.replace(/\s/g,'-')}&name=${name}`} target="_blank" rel="noreferrer">
          <img src='https://pbs.twimg.com/profile_images/943219769850785792/pohESfYc_400x400.jpg' alt={`${name}의 심크`}/>
        </a>
      </span>
      {/* <a>타임라인</a> <a>특성</a> <a>전투정보실</a> */}
    </li>

    <li className={cx('option')} style={(cnt === 0 || sourceID !== '' || sourceID_ing !== '') ? {} : {display:'none'}}>
      {(sourceID === '' || sourceID_ing === 'Y') ?
      <span className={cx('report_loading')}>
        <img src='/resource/img/loading_report.gif' alt='Loading icon' />
      </span> :
      <span>
        <a className={cx('wcl-href-btn')} href={`https://ko.warcraftlogs.com/reports/${report_code}#fight=${fightID}&type=${isHeal ? 'healing' : 'damage-done'}&source=${sourceID}`} target="_blank" rel="noreferrer">{isHeal ? compTxt3.substring(0,2) : (glang==='kr'?'입힌피해':'Damage')}</a>
        <a className={cx('wcl-href-btn')} href={`https://ko.warcraftlogs.com/reports/${report_code}#fight=${fightID}&type=summary&source=${sourceID}`} target="_blank" rel="noreferrer">{glang==='kr'?'특성':'Summary'}</a>
        <a className={cx('wcl-href-btn')} href={`https://ko.warcraftlogs.com/reports/${report_code}#fight=${fightID}&type=auras&source=${sourceID}`} target="_blank" rel="noreferrer">{glang==='kr'?'버프':'Buffs'}</a>
        <a className={cx('wcl-href-btn')} href={`https://ko.warcraftlogs.com/reports/${report_code}#fight=${fightID}&type=casts&source=${sourceID}&view=timeline`} target="_blank" rel="noreferrer">{isHeal ? (glang==='kr'?'힐':'heal') : (glang==='kr'?'딜':'Damage')}{glang==='kr'?'사이클':'cycle'}</a>
      </span>
      }
    </li>
    </div>
  )
}

const WowFind = ({fnWclFilter, wclFind, getReportData, lang}) => {
  glang = lang;
  const {url, wclFilter0, wclFilter1, wclFilter2, wclFilter3, wclFilter4, ranker, ranker_pending} = wclFind;
  const compUrl = url + wclFilter0.value + wclFilter1.value + wclFilter2.value + wclFilter3.value + wclFilter4.value;
  const compTxt1 = (wclFilter1.text === '' ? (glang==='kr'?'모든보스':'AllBoss') : wclFilter1.text) +' '+ (wclFilter2.text === '' ? (glang==='kr'?'신화':'Mythic') : wclFilter2.text) +' '+ (wclFilter3.text === '' ? (glang==='kr'?'월드':'World') : wclFilter3.text) + ' ';
  const compTxt2 = (wclFilter4.classes === '' ? wclFilter4.text : (wclFilter4.text+wclFilter4.classes)) + ' ';
  const compTxt3 = (wclFilter0.text === '' ? (glang==='kr'?'피해순위':'dps rank') : wclFilter0.text+(glang==='kr'?'순위':'lank'));
  const classColor = (wclFilter4.color === '#fff' ? '#000' : wclFilter4.color);

  const wclFilterRender = (flag) => {
    const wclFilterName = `wclFilter${flag}`;
    const wclFilterTemp = wclFilter[wclFilterName] === undefined ? [] : 
      wclFilter[wclFilterName];
    
    const html = wclFilterTemp.map((ele, cnt) => {
      const {
        classes, color, filterName, value, checked, 
        filterName_eng, classes_eng
      } = ele;
      const liStyle = {
        backgroundColor: color
      }
      
      return (
        <li key={cnt} style={liStyle} alt={filterName}>
          <input 
            type="radio" id={`${wclFilterName}_url${cnt}`} 
            name={wclFilterName} value={value} 
            onChange={fnWclFilter} 
            alt={(glang==='kr'?filterName:filterName_eng)+','+color+','+(glang==='kr'?classes:classes_eng)} 
            checked={checked}
          />
          <label htmlFor={`${wclFilterName}_url${cnt}`}><span>{glang==='kr'?filterName:filterName_eng}</span></label>
        </li>
      )
    });

    return html;
  }

  const rankList = ranker.map((item, cnt) => {
    const {name, server, report, amount, specIconIndex, sourceID, sourceID_ing} = item;
    const region = !isNull(server) ? server.region : '';
    const server_name = !isNull(server) ? server.name : '';
    const report_code = !isNull(report) ? report.code : '';
    const fightID = !isNull(report) ? report.fightID : '';

    return (
      <LankObject key={cnt} cnt={cnt}
      classColor={classColor}
      name={name}
      region={region}
      txt3={wclFilter3.text}
      report_code={report_code}
      fightID={fightID}
      amount={amount}
      server_name={server_name}
      specIconIndex={specIconIndex}
      sourceID={sourceID}
      getReportData={getReportData}
      sourceID_ing={sourceID_ing}
      compTxt3={compTxt3}
      />
    )
  })

  return (
    <section className={cx('main-contents')}>
      {/* {JSON.stringify(wclFind)} */}
      {/* {wclFilter0.value +"/"+JSON.stringify(wclFilter1) +"/"+ JSON.stringify(wclFilter4)} */}
      {/* <Adsense970250/> */}
      <Adsense72890/>
      <div className={cx('wcl-filter')}>
        <ul>{wclFilterRender('0')}</ul>
        <ul>{wclFilterRender('1')}</ul>
        <ul>{wclFilterRender('2')}</ul>
        <ul>{wclFilterRender('3')}</ul>
        <ul>{wclFilterRender('4')}</ul>
        {/* <ul>{wclFilterRender('5')}</ul> */}
      </div>
      
      <div className={cx('wcl-url')}>
        <div>[{compTxt1}<span style={{color:classColor}}>{compTxt2}</span>{compTxt3} TOP100]</div>
        {/* <a href={compUrl} target="_blank" rel="noreferrer">{compUrl}WCL바로가기</a> */}
      </div>
      <div className={cx('lank-list')}>
        {/* {compTxt2} */}
        {/* {JSON.stringify(ranker[0])} */}
        {/* <div>[{compTxt1}<span style={{color:classColor}}>{compTxt2}</span>{compTxt3 + ' TOP10'}]</div> */}
        {/* <div>[TOP 20]</div> */}

        {ranker_pending === '' ?
        <div className={cx('loding')}>{glang==='kr'?'보스와 직업을 선택하면 상위랭커 목록이 표시됩니다.':'When you select a boss and class, a list of top rankers is displayed.'}</div> : (
        ranker_pending === 'Y' ?
        <div className={cx('loding')}>{glang==='kr'?'불러오는 중...':'Loading...'}</div> :
        <ul className={cx('lank-list-ul')}>
          {rankList}
        </ul>
        )}
      </div>

      <div className={cx('wcl-url-link')}>
        [<span style={{color:classColor}}>{compTxt2}</span> {compTxt3} {glang==='kr'?'리스트 WCL바로가기':' list wcl URL'}]<br/>
        <a href={compUrl} target="_blank" rel="noreferrer">{compUrl}</a>
      </div>
      
      
      
    </section>
  );
}

export default WowFind;

const isNull = (value) => {
  return value === null || value === undefined;
}